import { APP_CONFIG } from '../../config';

const getChannelScriptText = (
  botId: string,
  channelId: string,
  buttonId: string,
  joinFlow?: string,
  leaveFlow?: string,
) => {
  return `<script>
const urlParams = new URLSearchParams(window.location.search);

const params = Object.fromEntries(urlParams.entries());

const str = [];
  for (const p in params){
      if (params.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(params[p]));
    }
  }
    
const link = \`${APP_CONFIG.API_URL}/ext/${botId}/${channelId}/${
    joinFlow ?? null
  }/${leaveFlow ?? null}/invite?\${str.join("&")}\`;


const fallbackLink = ''; // put you default link here
let linkToOpen;

fetch(link).then(r => r.json()).then(({inviteLink}) => {
    linkToOpen = inviteLink || fallbackLink
}).catch(() => {
    linkToOpen = fallbackLink;
})

const addLinkToButton = () => {
    const button = document.getElementById("${buttonId}");
    if(!button) return;
    
    button.onclick = () => {
       window.location.href = linkToOpen;
    }
}

addLinkToButton()
</script>`;
};

export default getChannelScriptText;
